import { LOCAL_CRYPTO_KEY_STORAGE, localDecrypt, localEncrypt } from './localCrypto'

function isExcludedKey(key: string): boolean {
  return key === LOCAL_CRYPTO_KEY_STORAGE
}

/**
 * 与原生 localStorage 同 API 的加密存储层：写入时 SM4 加密，读取时自动解密。
 * 升级前已存在的明文数据仍可正常读取，下次写入时自动转为密文。
 */
export const secureLocalStorage = {
  getItem(key: string): string | null {
    try {
      const raw = localStorage.getItem(key)
      if (raw == null || raw === '') return raw
      if (isExcludedKey(key)) return raw

      const decrypted = localDecrypt(raw)
      if (decrypted != null) return decrypted

      // 兼容历史明文
      return raw
    } catch {
      return null
    }
  },

  setItem(key: string, value: string): void {
    try {
      if (isExcludedKey(key)) {
        localStorage.setItem(key, value)
        return
      }
      localStorage.setItem(key, localEncrypt(value))
    } catch {
      // 配额或隐私模式失败时忽略
    }
  },

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch {
      // ignore
    }
  },

  /** 列出所有键名（与原生 localStorage 一致，值为底层密文） */
  keys(): string[] {
    try {
      return Object.keys(localStorage)
    } catch {
      return []
    }
  },
}
